import { RemoteAddAccount } from "../../../../data/usecases";
import { CreateUser } from "../../../../domain/usecases";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteCreateUser = (): CreateUser =>
  new RemoteAddAccount(makeApiUrl("/users/create"), makeAxiosHttpClient());
